





















































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { WidgetConfiguration } from "../interfaces/widgetConfiguration";
import { WidgetState } from "../interfaces/widgetState";
import { WidgetPayload } from "../interfaces/widgetPayload";
import WidgetGrid from "../components/WidgetGrid.vue";
import MobileWidgetGrid from "../components/MobileWidgetGrid.vue";
import { Layout } from "../interfaces/layout";
import { SocketService } from "../services/socketService";
import StudioBar from "@/components/StudioBar.vue";
import { User, ManualSignUp } from "../interfaces/user";
import GuestLogin from "@/components/GuestLogin.vue";
import { Script } from "../interfaces/script";
import ModifyScriptCard from "@/components/ModifyScriptCard.vue";
import ParticipantInfoCard from "@/components/ParticipantInfoCard.vue";
import { ScriptService } from "../services/scriptService";
import { StudioAttributes } from "../interfaces/studioAttributes";
import { StudioService } from "../services/roomService";
import CheckAuthLogin from "@/components/CheckAuthLogin.vue";
import randomstring from "randomstring";
import SpecialSignUp from "@/components/SpecialSignUp.vue";
import BackgroundSettings from "@/interfaces/studioBackground";
import FullscreenButton from "@/components/customActions/fullscreenButton.vue";
import { Page } from "@/interfaces/page";
import ConfirmDeleteDialog from "../components/customActions/ConfirmDeleteDialog.vue";
import { PublicVibrixEvent } from "@/interfaces/vibrixEvent";
import { VibrixEventRegistration } from "@/interfaces/vibrixEventRegistration";
import { EventService } from "@/services/eventService";
import { StudioState } from "@/interfaces/studioState";
import { ReportService } from "@/services/reportService";
import { DateService } from "@/services/dateService";

@Component({
    components: {
        WidgetGrid,
        StudioBar,
        GuestLogin,
        ModifyScriptCard,
        ParticipantInfoCard,
        CheckAuthLogin,
        SpecialSignUp,
        FullscreenButton,
        MobileWidgetGrid,
        ConfirmDeleteDialog,
    },
    // beforeRouteEnter: authGuard,
    beforeRouteLeave(to, from, next) {
        if (to.path.startsWith("/events/join")) {
            next();
            return;
        }
        const answer = window.confirm(this.$t("studio.onleave") as string);
        if (answer) {
            this.$store.commit("resetStudio");
            next();
        } else {
            next(false);
        }
    },
})
export default class Studio extends Vue {
    /* eslint-disable @typescript-eslint/camelcase */

    @Prop() studioId!: string;
    @Prop() registrationId?: string;

    public mounting = true;
    public studioChanging = false;
    public notFoundMessageVisible = false;
    public blockedMessageVisible = false;
    public loading = false;
    public authFlow = false;
    public authFlowComplete = false;
    public showParticipantsDialog = false;
    public loadScriptDialog = false;
    public currentPage = 0;
    public guestReconnects = 0;
    // says wether studio is locked
    public authorizationActive: boolean = false;
    public specialSignUpActive: boolean = false;
    // pass to special signup form to prefill
    public tempEmail: string = "";
    public showMobileToolbar: boolean = false;
    public navigationVisible: boolean = true;
    public scriptLoadWarning: boolean = false;
    // check if auth flow for event guests is done
    public registrationValidated: boolean = false;

    public get maxPage(): number {
        return (this.script?.pages.length ?? 0) - 1;
    }
    public token: string = "";
    public script: Script | null = null;

    public async loadRegistrationAndEvent(registrationId: string) {
        if (this.registrationId) {
            this.loading = true;
            try {
                const registration = await EventService.getEventRegistration(
                    registrationId
                );
                const event = await EventService.getEventByIdPublic(
                    registration.event_id
                );

                return { registration, event };
            } catch {
                return null;
            } finally {
                this.loading = false;
            }
        }
    }

    public async validateEvent(e: {
        registration: VibrixEventRegistration;
        event: PublicVibrixEvent;
    }) {
        const { registration, event } = e;
        if (event.studio_id != this.studioId) {
            return false;
        }
        if (new Date(event.end_time) < new Date()) {
            return false;
        }
        if (this.authorizationActive) {
            const authLevel = await StudioService.checkAuthorizationLists(
                this.studioId,
                registration.signupMeta.email
            );
            if (authLevel.blocked) {
                return false;
            }
        }
        return true;
    }

    public mounted() {
        if (this.$auth) {
            this.init();
            return;
        }
        const stopWatch = this.$watch("$auth", auth => {
            //  TODO error log
            if (auth) {
                this.init();
                stopWatch();
            }
        });
    }
    public init() {
        if (!this.$auth.loading) {
            this.afterAuthentication();
        }
        this.$auth.$watch("loading", loading => {
            if (!loading) {
                this.afterAuthentication();
            }
        });
        StudioService.authorizationActive(this.studioId).then(result => {
            this.authorizationActive = result;
        });
    }

    public get cssProps() {
        const backgroundSettings: BackgroundSettings = this.$store.state.studio
            .backgroundSettings;
        if (backgroundSettings) {
            return {
                backgroundImage: `url(/api/file/by_id/${backgroundSettings.image})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: backgroundSettings.size,
                backgroundPosition: backgroundSettings.position,
            };
        } else return {};
    }

    public async afterAuthentication() {
        await this.onStudioChange(this.studioId);
        setTimeout(() => (this.notFoundMessageVisible = true), 5000);
        this.mounting = false;
    }

    public get user(): User | null {
        return this.$store.state.user;
    }

    public get healthStatus(): boolean {
        if (this.$store.state.studio)
            return this.$store.state.studio.healthySession;
        else return true;
    }
    @Watch("healthStatus")
    public healthWatcher(newHealth: boolean, oldHealth: boolean) {
        if (!oldHealth && newHealth) {
            this.$store.commit("showSnackbar", {
                color: "success",
                text: this.$t("studio.reconnected"),
            });
        }
    }

    public doGuestLogin() {
        this.authFlow = false;
        this.authFlowComplete = true;
    }

    public async doSpecialSignup({ ...signUpDetails }: ManualSignUp) {
        const id = `guest|${randomstring.generate()}`;
        signUpDetails.id = id;
        await StudioService.signUpMeta(this.studioId, signUpDetails);
        const registeredUser: User = {
            id: id,
            email: signUpDetails.email,
            name: signUpDetails.name,
            surname: signUpDetails.surname,
            displayname: `${signUpDetails.name} ${signUpDetails.surname}`,
            is_active: false,
            is_guest: true,
            own_studios: [],
            joined_studios: [],
            scripts: [],
        };
        this.authFlowComplete = true;
        this.authorizationActive = false;
        this.specialSignUpActive = false;
        this.$store.commit("setUser", { user: registeredUser });
    }

    public async checkAuth(event: { email: string; username: string }) {
        const authLevel = await StudioService.checkAuthorizationLists(
            this.studioId,
            event.email
        );
        if (authLevel.blocked) {
            this.blockedMessageVisible = true;
        } else if (authLevel.allowed) {
            const registeredUser: User = {
                id: `guest|${randomstring.generate()}`,
                email: event.email,
                name: event.username,
                surname: event.username,
                displayname: event.username,
                is_active: false,
                is_guest: true,
                own_studios: [],
                joined_studios: [],
                scripts: [],
            };
            this.authFlowComplete = true;
            this.authorizationActive = false;
            this.$store.commit("setUser", { user: registeredUser });
        } else {
            this.tempEmail = event.email;
            this.specialSignUpActive = true;
            this.authorizationActive = false;
        }
    }

    public doReconnect() {
        ++this.guestReconnects;
        this.onStudioChange(this.studioId, undefined, this.guestReconnects);
    }

    @Watch("$store.state.user")
    public userwatch(newUser: User, oldUser: User) {
        // only join again when user was null before
        if (!oldUser) {
            this.onStudioChange(this.studioId);
        }
    }

    public async doEventLogin(registrationId: string) {
        const eventData = await this.loadRegistrationAndEvent(registrationId);
        if (!eventData || !(await this.validateEvent(eventData))) {
            this.$router.replace(`/events/join/${registrationId}`);
            return;
        }
        const eventUser: User = {
            id: `eventguest|${registrationId}`,
            email: eventData.registration.signupMeta.email,
            name: eventData.registration.signupMeta.name ?? "Guest",
            surname: eventData.registration.signupMeta.lastname ?? "Event",
            displayname: eventData.registration.signupMeta.name
                ? `${eventData.registration?.signupMeta.name} ${eventData.registration.signupMeta.lastname}`
                : eventData.registration.signupMeta.email,
            is_active: false,
            is_guest: true,
            own_studios: [],
            joined_studios: [],
            scripts: [],
        };
        this.authorizationActive = false;
        this.specialSignUpActive = false;
        this.$store.commit("setUser", { user: eventUser });
    }

    @Watch("studioId")
    public async onStudioChange(
        newStudioId: string,
        oldStudioId?: string,
        reconnect?: number
    ) {
        if (this.registrationId && !this.registrationValidated) {
            this.registrationValidated = true;
            await this.doEventLogin(this.registrationId);
            return;
        }
        // wenns keinen user gibt -> false, wenn array mit studios länger als 1 -> true, sonst false
        const isOwnStudio = this.user
            ? this.user.own_studios.filter(s => {
                  return s.studio.studioId == newStudioId;
              }).length > 0
                ? true
                : false
            : false;
        if (isOwnStudio) {
            this.authFlowComplete = true;
        }

        this.studioChanging = true;
        try {
            this.authFlow = false;
            if (oldStudioId) {
                SocketService.leaveStudio(oldStudioId);
            }
            let token = null;
            try {
                token = await this.$auth?.getTokenSilently();
                this.token = token;
            } catch {
                token = null;
            }
            if (!token) {
                if (this.user && this.user?.is_guest) {
                    token = {
                        id: this.user.id + (reconnect || ""),
                        username: this.user.displayname,
                        email: this.user.email,
                    };
                } else {
                    this.authFlow = true;
                    return;
                }
            }
            if (
                isOwnStudio ||
                this.authFlowComplete ||
                !this.authorizationActive
            ) {
                await SocketService.joinStudio(newStudioId, token);
            } else {
                this.authFlow = true;
            }
        } finally {
            this.studioChanging = false;
        }
    }

    public beforeDestroy() {
        SocketService.leaveStudio(this.studioId);
    }

    public toolboxClick(event: { type: string }) {
        const layout = {
            x: 0,
            y: 0,
            w: 3,
            h: 3,
        };
        SocketService.addWidget(this.studioId, event.type, layout);
    }

    public updateState(event: {
        config: WidgetConfiguration<WidgetState, WidgetPayload>;
        payload: WidgetPayload;
    }) {
        SocketService.updateWidgetState(
            this.studioId,
            event.config,
            event.payload
        );
    }

    public removeWidget(widgetId: string) {
        const i = this.configLayout.findIndex(l => l.i == widgetId);
        this.configLayout.splice(i, 1);
        SocketService.removeWidget(this.studioId, widgetId);
    }

    public get isPresenter(): boolean {
        return this.$store.getters.isPresenter;
    }

    public get configurations():
        | WidgetConfiguration<WidgetState, WidgetPayload>[]
        | null {
        return this.$store.state.studio?.widgetConfig;
    }

    public set configurations(
        v: WidgetConfiguration<WidgetState, WidgetPayload>[] | null
    ) {
        if (!v) {
            return;
        }
        SocketService.widgetConfigUpdate(this.studioId, v);
    }

    @Watch("configurations")
    public onConfigurationsChange(
        config: WidgetConfiguration<WidgetState, WidgetPayload>[]
    ) {
        if (this.script) {
            const page = this.script.pages[this.currentPage];
            if (page) {
                page.widgetConfig = config;
            }
        }
    }

    public get configLayout() {
        if (!this.$store.state.studio) {
            return [];
        }
        const layout = this.$store.state.studio.layout as Layout[];
        const jitsiIndex = layout.findIndex(x => x.i === "jitsi");
        if (jitsiIndex && jitsiIndex >= 0) {
            const [jitsi] = layout.splice(jitsiIndex, 1);
            layout.unshift(jitsi);
        }
        return layout;
    }

    public set configLayout(v: Layout[]) {
        if (this.script) {
            const page = this.script.pages[this.currentPage];
            if (page) {
                page.layout = v;
            }
        }

        this.$store.commit("localLayoutUpdated", {
            layout: v,
        });
        SocketService.updateLayout(this.studioId, v);
    }

    public get fullscreenWidgetId(): string | null {
        return this.attributes?.fullscreenWidgetId ?? null;
    }

    public set fullscreenWidgetId(v: string | null) {
        this.attributes = {
            fullscreenWidgetId: v,
        };
    }

    public get attributes(): StudioAttributes | null {
        return this.$store.state.studio?.attributes ?? null;
    }

    public set attributes(v: StudioAttributes | null) {
        if (!v) {
            return;
        }
        // die attribute werden aus der page gelesen, participants ist dynamisch und soll im studio nicht überschrieben werden
        v.participants = this.$store.state.studio?.attributes.participants;

        if (this.script) {
            const page = this.script.pages[this.currentPage];
            if (page) {
                page.attributes = { ...page.attributes, ...v };
            }
        }
        this.$store.commit("localAttributesUpdated", {
            attributes: v,
        });
        if (this.isPresenter) {
            SocketService.updateAttributes(this.studioId, v);
        }
    }

    public studioAttributesChanged(event: Partial<StudioAttributes>) {
        const v = {
            fullscreenWidgetId: this.fullscreenWidgetId,
            ...event,
        };
        this.$store.commit("localAttributesUpdated", {
            attributes: v,
        });
        SocketService.updateAttributes(this.studioId, v);
    }

    public onFullscreen(event: { widgetId: string; fullscreen: boolean }) {
        this.fullscreenWidgetId = event.fullscreen ? event.widgetId : null;
    }

    public startLoad() {
        if (this.script) {
            this.scriptLoadWarning = true;
            return;
        }
        this.loadScriptDialog = true;
    }

    public async stopLoad(confirmation: boolean) {
        this.scriptLoadWarning = false;
        if (confirmation) {
            // first save automatic report
            let payload:
                | Page[]
                | Omit<
                      StudioState,
                      | "presenters"
                      | "users"
                      | "quick_connect_codes"
                      | "healthySession"
                  >[] = [];
            const recentStudio = await StudioService.getStudio(
                this.studioId,
                this.token
            );
            const {
                studioName,
                studioId,
                layout,
                widgetConfig,
                attributes,
                backgroundSettings,
                authorizationActive,
            } = recentStudio.studio;
            payload = [
                {
                    studioName,
                    studioId,
                    layout,
                    widgetConfig,
                    attributes,
                    backgroundSettings,
                    authorizationActive,
                },
            ];

            if (this.script) {
                this.script.pages[this.currentPage].widgetConfig =
                    recentStudio.studio.widgetConfig;
                payload = this.script.pages;
            }
            ReportService.createReport(
                `Autosave - ${DateService.formatIsoStringShort(
                    new Date().toString(),
                    this.$i18n.locale
                )}`,
                this.$store.state.user.id,
                this.studioId,
                payload,
                this.token
            );
        }
        this.loadScriptDialog = confirmation;
    }
    public loadParticipantsDialog() {
        this.showParticipantsDialog = true;
    }
    public setPage(event: { index: number }) {
        if (event.index < 0 || event.index > this.maxPage || !this.script) {
            return;
        }

        this.currentPage = event.index;
        const page = this.script.pages[this.currentPage];

        if (page) {
            const currentIds = this.configurations?.map(x => x.widgetId) || [];
            this.configurations = page.widgetConfig.map(widget => {
                if (
                    currentIds.includes(widget.widgetId) &&
                    this.configurations
                ) {
                    widget.state =
                        this.configurations.find(
                            x => x.widgetId == widget.widgetId
                        )?.state || {};
                    return widget;
                } else return widget;
            });
            this.configLayout = page.layout;
            this.attributes = page.attributes;
            SocketService.updateBackground(
                this.studioId,
                page.backgroundSettings
            );
        }
    }

    public async load(script: { id: string; name: string }) {
        this.loading = true;
        try {
            const user = this.user;
            if (!user) {
                return;
            }
            // reset everything
            this.configurations = [];

            const fullScript: Script = await ScriptService.getScriptById(
                script.id,
                this.token
            );
            fullScript.pages.sort(
                (pageA: Page, pageB: Page) => pageA.id - pageB.id
            );
            fullScript.pages.forEach(page =>
                page.widgetConfig.forEach(w => {
                    if (this.configurations) {
                        const current = this.configurations.find(
                            c => c.widgetId === w.widgetId
                        );
                        if (current) {
                            w.state = current.state;
                        }
                    }
                })
            );
            this.script = fullScript;
            this.setPage({ index: 0 });
        } finally {
            this.loadScriptDialog = false;
            this.loading = false;
        }
    }
    public async deleteScript(id: string) {
        if (id) {
            await ScriptService.deleteScript(id, this.token);
            this.$store.commit("removeUserScript", id);
        }
    }

    public navigationToggle(newValue: boolean) {
        this.navigationVisible = newValue;
    }
}
